import type { ReduxState, ResolvedEdiblesState } from "@dashboard/types";

import { RestaurantSelectedAction } from "./restaurantReducer";

export type ResolvedEdiblesReducerAction =
  | { type: "FETCHED_RESOLVED_EDIBLES"; payload: ResolvedEdiblesState }
  | RestaurantSelectedAction;

export const resolvedEdiblesReducer: (
  state: ReduxState["resolvedEdibles"] | undefined,
  action: ResolvedEdiblesReducerAction
) => ReduxState["resolvedEdibles"] = (
  state: ReduxState["resolvedEdibles"] = {
    initialResolvedEdiblesLoading: true,
    resolvedDishesById: {},
    resolvedProductsById: {},
  },
  action: ResolvedEdiblesReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_SELECTED":
      return {
        ...state,
        initialResolvedEdiblesLoading: true,
      };
    case "FETCHED_RESOLVED_EDIBLES":
      return {
        ...state,
        initialResolvedEdiblesLoading: false,
        resolvedDishesById: action.payload.resolvedDishesById,
        resolvedProductsById: action.payload.resolvedProductsById,
      };
    default:
      return state;
  }
};
